import React, { useCallback, useState } from 'react';
import { ErrorModal } from '@common-fe/common-fe';

import ModalWrapper from '@/components/wrappers/ModalWrapper';
import { useSnackbar } from '@/modules/core';
import { SnackbarState } from '@/modules/core/core.types';

import { DependentPayload } from '../../employee.types';

import { AddDependentForm } from './AddDependentForm';
import { SSN_UNIQUE_ERROR_MESSAGE, useSsnConflictError } from './hooks';

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
}

export const AddDependentModal: React.FC<Props> = ({ visible, onSetVisible }) => {
  const { handleAddPermanentSnackbar } = useSnackbar();
  const [isSsnConflictVisible, setSsnConflictVisible] = useState(false);
  const handleError = useSsnConflictError({ setSsnConflictVisible });
  const onCancel = useCallback(() => onSetVisible(false), [onSetVisible]);
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  const onSuccess = useCallback((response?: any) => {
    const addedDependent: DependentPayload | undefined = response?.data;
    handleAddPermanentSnackbar({
      text: `${addedDependent?.first_name} ${addedDependent?.last_name} was added successfully!`,
      state: SnackbarState.positive,
      closeIcon: true,
    });
    onCancel();
  }, [handleAddPermanentSnackbar, onCancel]);

  return (
    <>
      <ModalWrapper
        visible={visible}
        onSetVisible={onCancel}
        title="Add a Dependent"
        isClosingByClickOutsideBlocked={isSsnConflictVisible}
      >
        <AddDependentForm onCancel={onCancel} onSuccess={onSuccess} onError={handleError} />
      </ModalWrapper>
      <ErrorModal
        testId="add-dependent-ssn-conflict-modal"
        visible={isSsnConflictVisible}
        onSetVisible={setSsnConflictVisible}
        header={SSN_UNIQUE_ERROR_MESSAGE}
        buttonText="Got It!"
      />
    </>
  );
};
